export default "__VITE_ASSET__B$NnTwC6__"